export default {
	en: {},
	pt: {
		title: {
			mobile: 'O endereço dos <br/>melhores endereços',
			desktop: 'O endereço dos melhores endereços'
		},
		titleOnTempHeroMessage: {
			mobile: 'O endereço dos melhores endereços.<br/>Agora em Curitiba.',
			desktop: 'O endereço dos melhores endereços.<br/>Agora em Curitiba.'
		}
	}
};
